export { default as Collapsible } from './Collapsible';
export { default as CollapsibleContent } from './CollapsibleContent';
export { default as CollapsibleTrigger } from './CollapsibleTrigger';
export * from './Collapsible.Context';